import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { brandInfo } from '@/mocks/site'

export default function Hero() {
  const { t } = useTranslation()

  const heroBadges = [
    { id: 'hb1', icon: 'ri-award-line', text: t('hero.badgeSince') },
    { id: 'hb2', icon: 'ri-heart-3-line', text: t('hero.badgeWeddings') },
    { id: 'hb3', icon: 'ri-map-pin-2-line', text: t('hero.badgePlaces') },
  ]

  return (
    <section id="home" className="relative w-full min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://readdy.ai/api/search-image?query=cinematic%20luxury%20photography%20studio%20scene%20with%20warm%20golden%20lighting%2C%20vintage%20cameras%20and%20elegant%20framed%20portraits%20in%20the%20background%2C%20deep%20brown%20and%20amber%20tones%2C%20artistic%20moody%20atmosphere%2C%20soft%20bokeh%20light%20particles%2C%20premium%20editorial%20look&width=1920&height=1080&seq=shabi-hero-bg-01&orientation=landscape"
          alt="Shabi Media cinematic photography studio with warm golden lighting"
          title="Shabi Media — photography, videography and creative design studio in Madurai and Karaikudi"
          className="w-full h-full object-cover object-top animate-slow-zoom"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/45 to-black/70" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-transparent to-black/40" />
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 pt-28 pb-20 md:pt-32 md:pb-24">
        <div className="max-w-4xl">
          <div className="inline-flex items-center gap-3 mb-6 animate-fade-up">
            <span className="h-px w-10 bg-primary-400" />
            <span className="section-label text-primary-300 text-[11px] md:text-xs font-medium">
              {t('hero.tagline')}
            </span>
          </div>

          <h1 className="font-heading text-background-50 font-semibold leading-[1.05] text-4xl md:text-6xl lg:text-7xl animate-fade-up">
            {t('hero.titleLine1')}
            <br />
            {t('hero.titleLine2pre')}
            <span className="text-primary-400 italic">{t('hero.titleLine2Accent')}</span>
          </h1>

          <p className="mt-6 md:mt-8 text-base md:text-lg text-background-200/90 max-w-2xl leading-relaxed animate-fade-up">
            {t('hero.desc')}
          </p>

          <div className="mt-9 md:mt-11 flex flex-col sm:flex-row gap-4 animate-fade-up">
            <a
              href={brandInfo.whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 h-12 px-8 rounded-md bg-primary-500 text-background-50 text-sm font-medium tracking-wide whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
            >
              <i className="ri-whatsapp-line text-lg" />
              {t('common.bookShoot')}
            </a>
            <Link
              to="/gallery"
              className="inline-flex items-center justify-center gap-2 h-12 px-8 rounded-md border border-background-100/50 text-background-50 text-sm font-medium tracking-wide whitespace-nowrap cursor-pointer hover:bg-background-50/10 transition-colors"
            >
              <i className="ri-image-2-line text-lg" />
              {t('common.viewWork')}
            </Link>
          </div>

          <div className="mt-12 md:mt-16 flex flex-wrap gap-3 md:gap-4 animate-fade-up">
            {heroBadges.map((badge) => (
              <div
                key={badge.id}
                className="flex items-center gap-2 px-4 py-2 rounded-full border border-background-100/25 bg-black/20 backdrop-blur-sm"
              >
                <i className={`${badge.icon} text-primary-400 text-base`} />
                <span className="text-xs md:text-sm text-background-100 whitespace-nowrap">{badge.text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}